<template>
	<b-row>
		<b-col cols="12">
			<Proposal />
		</b-col>
	</b-row>
</template>

<script>
import Proposal from '@/views/CustomerProfile/CenterComponents/Proposal/Proposal'

export default {
	components: {
		Proposal
	}
}
</script>